import { Component, OnInit,Input,Output,EventEmitter,SimpleChanges  } from '@angular/core';
import { NgbModal,NgbModalOptions  } from '@ng-bootstrap/ng-bootstrap';
import { ModalcontentComponent } from '../../layout/modalcontent/modalcontent.component';


@Component({
  selector: 'app-img-cropper',
  templateUrl: './img-cropper.component.html',
  styleUrls: ['./img-cropper.component.css']
})
export class ImgCropperComponent implements OnInit {
    @Input() editData: any; // Assuming editData is an input property
    @Input() ntype: any = 0; // Assuming editData is an input property
    @Output() imageUpload = new EventEmitter<File>();

    constructor(public modalService: NgbModal) { }

  
    imageChangedEvent: any = '';
    croppedImage: any = '';

    ngOnInit(): void {

        this.croppedImage = this.editData;
    }

    ngOnChanges(changes: SimpleChanges): void {

        this.checkeditData();

    }

    checkeditData() {
        this.croppedImage = this.editData;
    }
  
    openModal() {        

        // 設定 modal 選項
        const modalOptions: NgbModalOptions = {
            backdrop: 'static',  // 設定為 static backdrop
            keyboard: false,      // 如果不想讓使用者透過按鍵關閉 modal，也可以設定 keyboard 為 false
        };
      
        const modalRef = this.modalService.open(ModalcontentComponent,modalOptions);
      
        // 設定當 modal 關閉時的處理函式
        modalRef.result.then(
            (result) => {
                // 這裡是 modal 成功關閉時的處理邏輯
                // 你可以在這裡進行其他操作，如手動添加 modal-open 類別
                if(this.ntype == 1){
                    document.body.classList.add('nothing');
                }else{
                    document.body.classList.add('modal-open');
                }
            },
            (reason) => {
                // 這裡是 modal 關閉時的錯誤處理邏輯
                console.log('error in openModal');
            }
        );
      
      
        // 訂閱從 modal 發送回來的資料
        modalRef.componentInstance.dataSentBack.subscribe((returnedData) => {
            this.croppedImage = returnedData;
            this.imageUpload.emit(this.croppedImage);
        });

    }

    clearTmpImg(): void {
        this.croppedImage = '';
    }
}
